<template>
  <span></span>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      this.axios.get(`${vm.$store.state.filooServer}logout`).then(() => {
        vm.$session.destroy();
        vm.$router.push("/login");
      })
    },
  },
};
</script>
